export const DEFAULT_VIEWPORT_ITEM_COUNT = 8;

export const DEFAULT_ITEM_HEIGHT = 40;
